module.exports = __webpack_public_path__ + "img/enconstruccion.5d1260f9.png";